"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[366],{

/***/ 40366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ BackgroundWrapper; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);






var VideoBackgroundWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9636), __webpack_require__.e(7749), __webpack_require__.e(3253), __webpack_require__.e(7115), __webpack_require__.e(669), __webpack_require__.e(2844), __webpack_require__.e(5509), __webpack_require__.e(3123)]).then(__webpack_require__.bind(__webpack_require__, 83123));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(83123)];
    }
  }
});
var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});
function BackgroundWrapper(_ref) {
  var _backgroundAsset$fiel;

  var backgroundAsset = _ref.backgroundAsset,
      backgroundPosition = _ref.backgroundPosition,
      sectionOffsetTop = _ref.sectionOffsetTop,
      mainAssetOffsetTop = _ref.mainAssetOffsetTop,
      mainAssetOffsetRight = _ref.mainAssetOffsetRight,
      mainAssetOffsetBottom = _ref.mainAssetOffsetBottom,
      mainAssetOffsetLeft = _ref.mainAssetOffsetLeft,
      pauseLabel = _ref.pauseLabel,
      playLabel = _ref.playLabel,
      resetLabel = _ref.resetLabel,
      openTranscriptLabel = _ref.openTranscriptLabel,
      closeTranscriptLabel = _ref.closeTranscriptLabel,
      preloadImage = _ref.preloadImage,
      desktopBackgroundImage = _ref.desktopBackgroundImage,
      mobileBackgroundImage = _ref.mobileBackgroundImage,
      children = _ref.children;

  switch (backgroundAsset == null ? void 0 : (_backgroundAsset$fiel = backgroundAsset.fields) == null ? void 0 : _backgroundAsset$fiel.contentType) {
    case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_4__/* .ContentConstants.cloudinaryVideo */ .Kd.cloudinaryVideo:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(VideoBackgroundWrapper, {
        backgroundAsset: backgroundAsset,
        mainAssetOffsetTop: mainAssetOffsetTop,
        mainAssetOffsetRight: mainAssetOffsetRight,
        mainAssetOffsetBottom: mainAssetOffsetBottom,
        mainAssetOffsetLeft: mainAssetOffsetLeft,
        pauseLabel: pauseLabel,
        playLabel: playLabel,
        resetLabel: resetLabel,
        openTranscriptLabel: openTranscriptLabel,
        closeTranscriptLabel: closeTranscriptLabel,
        children: children
      });

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Image, {
        image: backgroundAsset,
        preloadImage: preloadImage,
        desktopBackgroundImage: desktopBackgroundImage,
        mobileBackgroundImage: mobileBackgroundImage,
        backgroundPosition: backgroundPosition,
        backgroundOffsetTop: sectionOffsetTop,
        children: children
      });
  }
}
BackgroundWrapper.defaultProps = {
  backgroundAsset: undefined,
  backgroundPosition: 0,
  sectionOffsetTop: 0,
  children: null
};

/***/ })

}]);